// @flow
import type { OperatorOptionsType } from '../constants/ApiTypes';

export const stringOperators: Array<OperatorOptionsType> = [
  {
    id: 'EQ',
    value: 'EQ',
    label: 'is equal to',
    multiple: false
  },
  {
    id: 'NEQ',
    value: 'NEQ',
    label: 'is not equal to',
    multiple: false
  },
  {
    id: 'IN',
    value: 'IN',
    label: 'is one of',
    multiple: true
  },
  {
    id: 'NOT_IN',
    value: 'NOT_IN',
    label: 'is not one of',
    multiple: true
  }
];

export const numberOperators: Array<OperatorOptionsType> = [
  {
    id: 'LT',
    value: 'LT',
    label: 'less than',
    multiple: false
  },
  {
    id: 'GT',
    value: 'GT',
    label: 'greater than',
    multiple: false
  },
  {
    id: 'LTEQ',
    value: 'LTEQ',
    label: 'less than or equal to',
    multiple: false
  },
  {
    id: 'GTEQ',
    value: 'GTEQ',
    label: 'greater than or equal to',
    multiple: false
  }
];

export const generalOperators: Array<OperatorOptionsType> = [
  {
    id: 'IS_NULL',
    value: 'IS_NULL',
    label: 'is not defined',
    multiple: false
  },
  {
    id: 'IS_NOT_NULL',
    value: 'IS_NOT_NULL',
    label: 'is defined',
    multiple: false
  }
];

export const typeFromOperator = (operatorId: string) => {
  if (numberOperators.find(operator => operator.id === operatorId)) {
    return 'NUMBER';
  }
  return 'STRING';
};



// WEBPACK FOOTER //
// ./src/util/AttributeUtils.js